import { render } from "./ProfileVehicle.view.vue?vue&type=template&id=21af4111"
import script from "./ProfileVehicle.view.vue?vue&type=script&lang=js"
export * from "./ProfileVehicle.view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__